

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface CommonMasterParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}
export interface ApptReminderCategory {
  id?: number;
   name:string; 
 
parameters?: CommonMasterParameter[];
links?: any;
}

export interface ApptSubType {
    id?: number;
     name:string; 
     code:string;
  parameters?: CommonMasterParameter[];
  links?: any;
}
export interface ApptReminder {
  id?: number;
   type:string; 
   code:string;
parameters?: CommonMasterParameter[];
links?: any;
}
export interface ApptMissedReason {
  id?: number;
   type:string; 
   code:string;
parameters?: CommonMasterParameter[];
links?: any;
}

export abstract class CommonMasterData {
  abstract list(url: string): Observable<any[]>;
  abstract create(url: string, data: any): Observable<any[]>;
  abstract update(url: string, data: any): Observable<any>;
 
}
